module.exports = __webpack_public_path__ + "img/icn-assurance.d59d0970.svg";